<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <PrimaryButton text v-on="on" @click.native.stop>
          Apply Link
          <template v-slot:prepend:icon>
            <v-icon color="primary" class="mr-2">
              mdi-link
            </v-icon>
          </template>
        </PrimaryButton>
      </template>
      <MenuList :items="menuItems" @select="action => action()" />
    </v-menu>
  </div>
</template>

<script>
import MenuList from "@/components/common/Menu/MenuList";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { POST_GLOBAL_MESSAGE } from "@/store/modules/global/action-types";
import { mapActions } from "vuex";
import { isPermissioned } from "@/utils/permissions";

export default {
  name: "ApplyLink",
  components: { MenuList, PrimaryButton },
  props: {
    booking: {
      type: Object,
      required: true
    }
  },
  computed: {
    menuItems() {
      return [
        {
          title: "Copy apply link to clipboard",
          action: () => this.copyLink()
        },
        ...(this.showPostDeadlineApplylink
          ? [
              {
                title: "Copy post-deadline apply link to clipboard",
                action: () => {
                  const params = `&adak=${this.booking.afterDeadlineApplyKey}`;
                  this.copyLink(params);
                }
              }
            ]
          : [])
      ];
    },
    currentBookingId() {
      return this.booking.id;
    },
    showPostDeadlineApplylink() {
      return (
        !this.booking.applyLinkOverride &&
        isPermissioned(
          `bookings[${this.currentBookingId}].view.after-deadline-apply-key`
        )
      );
    }
  },
  methods: {
    ...mapActions({ postGlobalMessage: POST_GLOBAL_MESSAGE }),
    handleSelect(action) {
      action();
    },
    copyLink(params) {
      const el = document.createElement("textarea");
      params = params || "";
      let link = `${process.env.VUE_APP_AUTH_URL}/login?select=true&booking_id=${this.currentBookingId}&utm_source=link${params}`;
      if (this.booking.applyLinkOverride) {
        link = this.booking.applyLinkOverride;
      }
      el.value = link;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.displayCopiedToClipboardMessage();
    },
    displayCopiedToClipboardMessage() {
      const message = {
        snackbar: true,
        type: "success",
        title: "Apply link copied to clipboard"
      };
      this.postGlobalMessage(message);
    }
  }
};
</script>

<style scoped></style>
